//
//
//      将本地图片拖拽到某个元素上，并获取路径
//
//
export default {
    methods: {
        AttchDropMulti(elem, callback) {
            elem.addEventListener("dragenter", function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, false);
            elem.addEventListener("dragover", function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, false);
            elem.addEventListener("drop", function (e) {
                e.stopPropagation();
                e.preventDefault();
                var fileList = e.dataTransfer.files;
                callback(fileList);
            }, false);
        },
        AttchDropper(elem, isHeic, callback) {
            elem.addEventListener("dragenter", function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, false);
            elem.addEventListener("dragover", function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, false);
            elem.addEventListener("drop", function (e) {
                e.stopPropagation();
                e.preventDefault();
                var fileLoad = e.dataTransfer.files[0];
                var common = /\.(jpg|jpeg|JPG|png|PNG|gif|GIF)$/.test(fileLoad.name);
                var heic = /\.(heic|HEIC)$/.test(fileLoad.name);
                //当前要处理 heic，如果是或否，就赋值给支持
                var sported = isHeic ? heic : common;
                if (!fileLoad || sported == false) {
                    window.toastr.error('不支持的文件类型...');
                    return;
                } else {
                    callback(fileLoad);
                }
            }, false);
        }
    }
};